import {CFMember, CFValue, isCFMember} from 'module/CustomField/type/CFType'

// use CF.isNull() for complete check!
export function isNullCFMember(cfMember?: CFMember | CFValue) {
	if (isCFMember(cfMember)) {
		return !cfMember || !cfMember.data && cfMember.data !== 0 && !cfMember.lat && cfMember.lat !== 0 && !cfMember.lon && cfMember.lon !== 0 && !cfMember.lazy
	} else {
		return cfMember === null || cfMember === undefined || cfMember === ''
	}
}